export default "/img/KM.fda41a92e9df0c55171b45954881f5c0.png";